import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import Rive from '@rive-app/react-canvas';

import {Stack} from 'shells/layout/stack/stack';
import {Link} from 'shells/link/link';
import {Body} from 'shells/typography/body';

import {CHURN_FORM_SUBMITTED_ANIMATION_SRC} from './consts';

import styles from './churn-page-submitted.module.css';

type Props = {
    csmInfo: any;
};

export function ChurnPageSubmitted(props: Props) {
    return (
        <div className={styles.content}>
            <Stack spacing={32} alignItems='center'>
                <div className={styles['animation-container']}>
                    <Rive src={CHURN_FORM_SUBMITTED_ANIMATION_SRC} />
                </div>
                <Body useDoyle={true} size='xlarge' isBold={true} textAlign='center'>
                    Thank you for your feedback!
                </Body>
                <Body textAlign='center'>
                    We appreciate you taking the time to share why you’re adjusting your Nutshell
                    plan. Our goal is to make sure Nutshell continues to deliver value for your
                    team.
                </Body>
                {props.csmInfo && (
                    <Body textAlign='center'>
                        If you’d like to talk through your setup or learn how to get more out of
                        your plan, our team is happy to help -{' '}
                        <Link variant='primary' href={props.csmInfo.calendlyLink} newTab={true}>
                            schedule a quick call with a Nutshell Advisor
                        </Link>
                        .
                    </Body>
                )}
                {/* @ts-expect-error */}
                <Link as={RoutedLink} to='/setup/billing' variant='button-primary' size='big'>
                    Back to billing page
                </Link>
            </Stack>
        </div>
    );
}
